define('common/container/CometdExtension',['underscore', 'bluebird'], function(_, Promise) {

    /**
     * @todo dhowlett Add support for non public cometd channels
     */
    function CometdExtension(cometdServiceId) {

        var self = this,
            cometdService,
            subscriptionManager;

        self.canHandleExtra = function(extraDefinition) {
            return !!extraDefinition.cometd;
        };

        self.beforeServiceInitialised = function(extraDefinition, extensionApi) {

            return Promise.all([
                extensionApi.container.get(cometdServiceId),
                extensionApi.resolveArg('subscriptionManager')
            ]).then(function(services) {
                cometdService = services[0];
                subscriptionManager = services[1];
            });

        };

        self.onServiceInstanceCreated = function(instance, extraDefinition, extensionApi) {

            var subscriptionDefinitions = extraDefinition.cometd;

            if ( !_.isArray(extraDefinition.cometd) ) {
                subscriptionDefinitions = [ extraDefinition.cometd ];
            }

            subscriptionDefinitions.forEach(function(subscriptionDefinition) {

                var subscription,
                    notifyCallback,
                    subscribeFn;

                if (subscriptionDefinition.subscribeToId) {

                    subscribeFn = cometdService[subscriptionDefinition.subscribeTo].bind(
                        cometdService,
                        instance[subscriptionDefinition.subscribeToId]
                    );

                } else {

                    subscribeFn = cometdService[subscriptionDefinition.subscribeTo].bind(cometdService);

                }

                subscription = subscribeFn(
                    _.template(subscriptionDefinition.path)(instance),
                    function(payload) {
                        notifyCallback(payload);
                    },
                    false
                );

                subscriptionManager.add(instance, subscriptionDefinition.methodName, {
                    start: function(callback) {
                        notifyCallback = callback;
                        subscription.subscribe();
                    },
                    stop: function() {
                        subscription.unsubscribe();
                    }
                });

                if (subscriptionDefinition.initialise !== false) {
                    subscriptionManager.start(instance, subscriptionDefinition.methodName);
                }

            });

        };

    }

    return CometdExtension;

});

